import { API_PATH, CDN_PATH, ENV_NAME } from './url';

import { APISettingName, PrintType } from 'types/api';

export const apiSpecEndpoint = () => `${API_PATH}docs`;
export const cdnEndpoint = () => `${CDN_PATH}`;

export const authThirdParty = (auth: 'google' | 'microsoft') =>
  `${
    ENV_NAME == 'dev' ? 'http://localhost:8080/' : API_PATH
  }auth/${auth}/login`;

// anonymous APIs
export const userEndpoint = () => `${API_PATH}user/`;
export const userAuthEndpoint = () => `${userEndpoint()}auth`;
export const userPasswordResetLinkEndpoint = (email: string) =>
  `${userEndpoint()}password-reset-link?email=${email}`;
export const validateUserResetTokenPasswordEndpoint = (
  email: string,
  token: string,
) => `${userEndpoint()}validate-reset-token?token=${token}&email=${email}`;
export const userResetPasswordEndpoint = () =>
  `${userEndpoint()}reset-password`;
export const userRefreshTokenEndpoint = () => `${userEndpoint()}token`;

export const anonymousPaymentEndpoint = (paymentId: string) =>
  `${API_PATH}payment/${paymentId}/`;

export const userPaymentDetailsEndpoint = (paymentId: string) =>
  `${anonymousPaymentEndpoint(paymentId)}details`;

export const anonymousPrintPaymentEndpoint = (id: string, type: PrintType) =>
  `${anonymousPaymentEndpoint(id)}download/${type}/`;

export const finishPrintingEndpoint = (id: string) =>
  `${anonymousPaymentEndpoint(id)}printed/`;

export const verifyCheckEndpoint = (id: string) =>
  `${API_PATH}payment/verify/${id}/`;

export const userInfoEndpoint = () => `${userEndpoint()}me`;

// user APIs
export const userAvatarEndpoint = () => `${userEndpoint()}avatar/`;
export const changePasswordEndpoint = () => `${userEndpoint()}change-password/`;
export const userSettingsEndpoint = () => `${userEndpoint()}settings`;
export const userPayeeEndpoint = () => `${API_PATH}payee/`;
export const payeeEditEndpoint = (payeeId: string) =>
  `${userPayeeEndpoint()}${payeeId}`;
export const userPaymentEndpoint = () => `${API_PATH}payment`;
export const globalPaymentSearchEndpoint = () =>
  `${userPaymentEndpoint()}/global-search`;

export const userTenantPayeeSearch = () =>
  `${userPayeeEndpoint()}/global-search`;

export const requestPaymentEndpoint = (tenantId: string) =>
  `${userPaymentEndpoint()}/${tenantId}/request`;

// tenant APIs
export const baseEndpoint = (tenantId: string) =>
  `${tenantEndpoint()}${tenantId}/`;
export const tenantEndpoint = () => `${API_PATH}tenant/`;
export const tenantSingleEndpoint = baseEndpoint;


export const tenantTypeaheadEndpoint = () =>
  `${API_PATH}tenant/typeahead`;

export const userTypeaheadEndpoint = (tenantId: string) =>
  `${baseEndpoint(tenantId)}user/typeahead`;

export const userListEndpoint = (tenantId: string) =>
  `${baseEndpoint(tenantId)}user/`;

export const inviteUserEndpoint = (tenantId: string) =>
  `${userListEndpoint(tenantId)}invite/`;

export const userSingleEndpoint = (tenantId: string, userId: string) =>
  `${baseEndpoint(tenantId)}user/${userId}/`;

export const userRightsEndpoint = (tenantId: string, userId: string) =>
  `${userSingleEndpoint(tenantId, userId)}rights/`;

// setting
export const settingEndpoint = (tenantId: string) =>
  `${baseEndpoint(tenantId)}setting/`;

export const settingSingleEndpoint = (tenantId: string, name: APISettingName) =>
  `${settingEndpoint(tenantId)}${name}`;

export const auditEndpoint = (tenantId: string) =>
  `${baseEndpoint(tenantId)}audit/`;
